import { Form, Input, InputNumber, Select, Switch } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const StoreAppointments = ({ form }) => {
  return (
    <SettingsContent title="APPOINTMENTS" icon={<FontAwesomeIcon icon={['far', 'calendar-check']} />}>
      <DescriptionBox
        className="w-100-P"
        title="Accepts Appointments"
        description="Show this store as a scheduling option for guests and staff. Turn off to hide it from booking."
        input={
          <Form.Item name="appointments_enabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
      {!!Form.useWatch('appointments_enabled', form) && (
        <div
          className="flex-col"
          style={{
            background: '#FAFAFA',
            padding: '32px',
            borderRadius: '4px',
            width: '100%',
            boxSizing: 'border-box',
          }}
        >
          {/* <DescriptionBox
            className="w-100-P"
            title="Same Day Appointments"
            description="Set the minimum hours in advance between now and the first available slot to prevent same-day or short-notice bookings."
            input={
              <Form.Item name="appointments_min_hours_ahead" style={{ marginBottom: 0 }}>
                <InputNumber suffix="hours" style={{ width: '110px' }} />
              </Form.Item>
            }
          /> */}
          <DescriptionBox
            className="w-100-P m-top-30"
            title="Virtual Appointments"
            description="Show “Virtual Appointment” as a booking option. Associates provide call or video details; the system does not generate a link."
            input={
              <Form.Item name="appointments_virtual_enabled" valuePropName="checked" style={{ marginBottom: 0 }}>
                <Switch />
              </Form.Item>
            }
          />
          <DescriptionBox
            className="w-100-P m-top-30"
            title="Allow Clients to Choose an Associate"
            description="When booking an appointment, allow clients to book with a specific associate"
            input={
              <Form.Item name="appointments_select_associate" valuePropName="checked" style={{ marginBottom: 0 }}>
                <Switch />
              </Form.Item>
            }
          />
          <DescriptionBox
            className="w-100-P m-top-30"
            title="Default Assigned Associate"
            description="When a client books an appointment, assign to the assigned associate if possible"
            input={
              <Form.Item name="use_assigned_associate" valuePropName="checked" style={{ marginBottom: 0 }}>
                <Switch />
              </Form.Item>
            }
          />
        </div>
      )}
    </SettingsContent>
  );
};
